"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 2a1 1 0 010 2v4l4 8v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1l4-8V4a1 1 0 110-2h6zm-2 2H9v4l-2 4h6l-2-4V4z"];
//# sourceMappingURL=lab-test.js.map